import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const useDisplayComponent = () => {
  const [isDisplay, setIsDisplay] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    const displayComponent = () => {
      pathname === "/" ? setIsDisplay(false) : setIsDisplay(true);
    };
    displayComponent();
  }, [pathname]);

  return { isDisplay };
};

export default useDisplayComponent;
